import { PropsWithChildren, useState } from 'react';

import { getEntityKindFromEntityType } from '@/modules/entities/utils/getEntityKindFromEntityType';

import { EntityDetailsContext } from './entityDetails.context';

function useEntityDetailsContextValue(): EntityDetailsContext {
  const [entityId, setEntityId] =
    useState<EntityDetailsContext['entityId']>(null);

  const [displayName, setDisplayName] =
    useState<EntityDetailsContext['displayName']>(null);

  const [entitySubtypeId, setEntitySubtypeId] =
    useState<EntityDetailsContext['entitySubtypeId']>(null);

  const [entityType, setEntityType] =
    useState<EntityDetailsContext['entityType']>(null);

  const [entityNotFound, setEntityNotFound] =
    useState<EntityDetailsContext['entityNotFound']>(false);

  return {
    entityId,
    setEntityId,

    displayName,
    setDisplayName,

    entitySubtypeId,
    setEntitySubtypeId,

    entityType,
    setEntityType,

    entityKind: entityType ? getEntityKindFromEntityType(entityType) : null,

    entityNotFound,
    setEntityNotFound,
  };
}

export const EntityDetailsProvider = ({
  children,
}: PropsWithChildren<unknown>) => {
  const value = useEntityDetailsContextValue();
  return (
    <EntityDetailsContext.Provider value={value}>
      {children}
    </EntityDetailsContext.Provider>
  );
};
